// extracted by mini-css-extract-plugin
module.exports = {"redirect":"eNw4wWy9","btn":"AraKv5T_","icon":"__6MCsjOkV"};